import React, { useEffect } from "react";
import Dataabout from "./Dataabout";
import Datasolution from "./Datasolution";
import Datapower from "./Datapower";
import Datafeatures from "./Datafeatures";
import Databanner from "./Databanner";

const Dataengineering = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
        <Databanner/>
      <Dataabout/>
      <Datasolution />

      <Datapower />
      <Datafeatures/>
    </div>
  );
};

export default Dataengineering;
